export const Home = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      id="navbar_home_icon"
      d="M19.7343 10.1758C20.0468 10.457 20.078 10.9258 19.828 11.2383C19.5468 11.5508 19.078 11.582 18.7655 11.332L18.0155 10.6758V16.4883C18.0155 17.8945 16.8905 18.9883 15.5155 18.9883H6.51554C5.10929 18.9883 4.01554 17.8945 4.01554 16.4883V10.6758L3.23429 11.332C2.92179 11.582 2.45304 11.5508 2.17179 11.2383C1.92179 10.9258 1.95304 10.457 2.26554 10.1758L10.5155 3.17578C10.7968 2.95703 11.203 2.95703 11.4843 3.17578L19.7343 10.1758ZM6.51554 17.4883H8.01554V12.7383C8.01554 12.0508 8.54679 11.4883 9.26554 11.4883H12.7655C13.453 11.4883 14.0155 12.0508 14.0155 12.7383V17.4883H15.5155C16.0468 17.4883 16.5155 17.0508 16.5155 16.4883V9.39453L11.0155 4.73828L5.51554 9.39453V16.4883C5.51554 17.0508 5.95304 17.4883 6.51554 17.4883ZM9.51554 17.4883H12.5155V12.9883H9.51554V17.4883Z"
      className="navbar_icons_color navbar_icons_hover_color"
    />
  </svg>
);

export const Video = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 67 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      id="navbar_video_icon"
      d="M58.1868 0.862549C62.6945 0.862549 66.4294 4.59748 66.4294 9.10516V50.3182C66.4294 54.9547 62.6945 58.5609 58.1868 58.5609H8.73114C4.09467 58.5609 0.488525 54.9547 0.488525 50.3182V9.10516C0.488525 4.59748 4.09467 0.862549 8.73114 0.862549H58.1868ZM14.9131 52.3789V41.0453H6.67049V50.3182C6.67049 51.4774 7.57202 52.3789 8.73114 52.3789H14.9131ZM14.9131 34.8633V24.5601H6.67049V34.8633H14.9131ZM14.9131 18.3781V7.04451H8.73114C7.57202 7.04451 6.67049 8.07484 6.67049 9.10516V18.3781H14.9131ZM45.8229 52.3789V32.8027H21.0951V52.3789H45.8229ZM45.8229 26.6207V7.04451H21.0951V26.6207H45.8229ZM60.2475 50.3182V41.0453H52.0049V52.3789H58.1868C59.2172 52.3789 60.2475 51.4774 60.2475 50.3182ZM60.2475 34.8633V24.5601H52.0049V34.8633H60.2475ZM60.2475 18.3781V9.10516C60.2475 8.07484 59.2172 7.04451 58.1868 7.04451H52.0049V18.3781H60.2475Z"
      className="navbar_icons_color navbar_icons_hover_color"
    />
  </svg>
);

export const Reports = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 77 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false">
    <path
      id="navbar_reports_icon"
      fillRule="evenodd"
      clipRule="evenodd"
      className="navbar_icons_color navbar_icons_hover_color"
      d="
        M12 4H45L57 16V54C57 58.418 53.418 62 49 62H12C7.582 62 4 58.418 4 54V12C4 7.582 7.582 4 12 4Z
        M45 4V16H57L45 4Z

        M18 46H24V34H18V46Z
        M28 46H34V28H28V46Z
        M38 46H44V38H38V46Z

        M22 20H40V24H22V20Z
      "
    />
  </svg>
);

export const Presentation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="navbar_icons_color navbar_icons_hover_color"
  >
    <path d="M2 3h20" />
    <path d="M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3" />
    <path d="m7 21 5-5 5 5" />
  </svg>
);

export const Collection = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 77 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      id="Vector"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.8678 0.930176C49.3527 0.930176 63.5297 15.2915 63.5297 33.0122C63.5297 40.4219 61.0469 47.2475 56.8839 52.6798C58.3042 53.3096 59.6718 54.2755 61.0658 55.2604C64.4678 57.6654 68.1072 60.2345 74.1653 54.2182L76.7121 56.8408C68.499 65.0025 63.5862 61.5325 58.9937 58.2876C57.351 57.1271 55.7612 56.0048 53.9754 55.9819C48.2714 61.6203 40.4727 65.0942 31.8754 65.0942C14.3792 65.0903 0.205933 50.729 0.205933 33.0122C0.205933 15.2953 14.3792 0.930176 31.8678 0.930176ZM31.8678 28.7061C34.215 28.7061 36.1138 30.6339 36.1138 33.0083C36.1138 35.3828 34.2112 37.3106 31.8678 37.3106C29.5245 37.3106 27.6219 35.3828 27.6219 33.0083C27.6219 30.6339 29.5245 28.7061 31.8678 28.7061ZM7.83131 18.9486C9.92603 15.2724 14.5638 14.0126 18.1919 16.1351C21.82 18.2577 23.0632 22.957 20.9685 26.6332C18.8738 30.3094 14.236 31.5692 10.6079 29.4466C6.97986 27.3241 5.73659 22.6248 7.83131 18.9486ZM7.83131 47.0719C5.73659 43.3957 6.97986 38.6964 10.6079 36.5739C14.236 34.4514 18.8738 35.7111 20.9685 39.3873C23.0632 43.0636 21.82 47.7629 18.1919 49.8854C14.5638 52.0079 9.92603 50.7481 7.83131 47.0719ZM31.8678 61.1316C27.6784 61.1316 24.2839 57.6921 24.2839 53.4471C24.2839 49.202 27.6784 45.7625 31.8678 45.7625C36.0573 45.7625 39.4518 49.202 39.4518 53.4471C39.4518 57.6921 36.0573 61.1316 31.8678 61.1316ZM55.9043 47.0719C53.8096 50.7481 49.1718 52.0079 45.5438 49.8854C41.9157 47.7629 40.6724 43.0636 42.7671 39.3873C44.8619 35.7111 49.4996 34.4514 53.1277 36.5739C56.7558 38.6964 57.9991 43.3957 55.9043 47.0719ZM55.9043 18.9486C57.9991 22.6248 56.7558 27.3241 53.1277 29.4466C49.4996 31.5692 44.8619 30.3094 42.7671 26.6332C40.6724 22.957 41.9157 18.2577 45.5438 16.1351C49.1718 14.0126 53.8096 15.2724 55.9043 18.9486ZM31.8678 4.88889C36.0573 4.88889 39.4518 8.32843 39.4518 12.5734C39.4518 16.8185 36.0573 20.258 31.8678 20.258C27.6784 20.258 24.2839 16.8185 24.2839 12.5734C24.2839 8.32843 27.6784 4.88889 31.8678 4.88889Z"
      className="navbar_icons_color navbar_icons_hover_color"
    />
  </svg>
);

export const Users = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 93 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      id="&#239;&#148;&#137;"
      d="M46.3927 46.8143C38.1869 46.8143 31.4206 40.192 31.5646 31.8422C31.5646 23.6363 38.1869 16.8701 46.3927 16.8701C54.5986 16.8701 61.3648 23.6363 61.3648 31.8422C61.3648 40.192 54.7425 46.8143 46.3927 46.8143ZM46.3927 23.7803C42.0739 23.7803 38.3308 27.5233 38.3308 31.8422C38.3308 36.305 42.0739 39.9041 46.3927 39.9041C50.8556 39.9041 54.4546 36.305 54.4546 31.8422C54.4546 27.5233 50.8556 23.7803 46.3927 23.7803ZM18.8959 23.7803C12.4176 23.7803 7.37894 18.7416 7.37894 12.2633C7.37894 5.92898 12.4176 0.746338 18.8959 0.746338C25.2303 0.746338 30.4129 5.92898 30.4129 12.2633C30.4129 18.7416 25.2303 23.7803 18.8959 23.7803ZM74.1775 23.7803C67.6992 23.7803 62.6605 18.7416 62.6605 12.2633C62.6605 5.92898 67.6992 0.746338 74.1775 0.746338C80.5118 0.746338 85.6944 5.92898 85.6944 12.2633C85.6944 18.7416 80.5118 23.7803 74.1775 23.7803ZM26.8139 31.8422C26.8139 36.7369 28.6854 41.1997 31.7086 44.5109H2.91611C1.47649 44.5109 0.46875 43.3592 0.46875 41.9196C0.46875 34.4335 6.08328 28.3871 13.1374 28.3871H21.9191C23.7906 28.3871 25.5182 28.819 27.1018 29.6828C26.9578 30.4026 26.8139 31.1224 26.8139 31.8422ZM79.792 28.3871C86.8461 28.3871 92.6046 34.4335 92.6046 41.9196C92.6046 43.3592 91.4529 44.5109 90.0133 44.5109H89.4375C85.6945 40.336 80.2239 37.6007 74.1775 37.6007C70.4344 37.6007 66.9793 38.7524 63.9561 40.4799C65.2518 37.8886 65.9716 35.0094 65.9716 31.8422C65.9716 31.1224 65.8276 30.4026 65.8276 29.6828C67.4112 28.963 69.1388 28.3871 71.0103 28.3871H79.792ZM55.6063 67.5449C57.0459 70.2801 58.9175 72.5835 61.2209 74.455H22.9269C20.6235 74.455 18.8959 72.8715 18.8959 70.712C18.8959 60.0588 27.9656 51.4211 39.3386 51.4211H53.5908C54.0227 51.4211 54.3107 51.565 54.5986 51.565C53.8788 53.7245 53.4469 56.0279 53.4469 58.3313H39.1946C32.8603 58.3313 27.5337 62.3622 26.094 67.5449H55.6063ZM89.4375 53.5805C89.5814 54.0124 89.4375 54.3003 89.1495 54.4443L86.4143 56.0279C86.7022 57.4675 86.7022 59.0511 86.4143 60.4907L89.1495 62.2183C89.4375 62.3622 89.5814 62.6501 89.4375 63.082C88.7177 65.3854 87.566 67.5449 85.9824 69.2724C85.6944 69.5603 85.2626 69.5603 84.9746 69.4164L82.2393 67.8328C81.0877 68.8405 79.648 69.5603 78.2084 69.9922V73.3034C78.2084 73.5913 78.0644 73.8792 77.6326 74.0232C75.3292 74.599 72.8818 74.599 70.5784 74.0232C70.1465 73.8792 70.0026 73.5913 70.0026 73.3034V69.9922C68.5629 69.5603 67.1233 68.8405 65.9716 67.8328L63.2363 69.4164C62.9484 69.5603 62.5165 69.5603 62.2286 69.2724C60.645 67.4009 59.3493 65.3854 58.7735 63.082C58.6295 62.6501 58.7735 62.3622 59.0614 62.2183L61.7967 60.4907C61.5088 59.0511 61.5088 57.4675 61.7967 56.0279L59.0614 54.4443C58.7735 54.1564 58.6295 53.8684 58.7735 53.4366C59.3493 51.1332 60.645 49.1177 62.2286 47.3901C62.5165 47.1022 62.9484 46.9582 63.2363 47.2462L65.9716 48.8298C67.1233 47.822 68.5629 46.9582 70.0026 46.5264V43.3592C70.0026 43.0713 70.1465 42.7833 70.4344 42.4954C72.7378 42.0635 75.1852 42.0635 77.4886 42.4954C77.9205 42.6394 78.2084 42.9273 78.2084 43.3592V46.6703C79.648 47.1022 80.9437 47.966 82.0954 48.9737L84.8307 47.2462C85.1186 47.1022 85.5505 47.2462 85.8384 47.3901C87.422 49.2616 88.7177 51.2771 89.4375 53.5805ZM74.1775 62.9381C76.6248 62.9381 78.7843 60.9226 78.7843 58.3313C78.7843 55.8839 76.6248 53.7245 74.1775 53.7245C71.5861 53.7245 69.5707 55.8839 69.5707 58.3313C69.5707 60.9226 71.5861 62.9381 74.1775 62.9381Z"
      className="navbar_icons_color navbar_icons_hover_color"
    />
  </svg>
);

export const Application = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 56 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      id="&#239;&#143;&#142;"
      d="M45.6124 0.0229492C51.0459 0.0229492 55.548 4.52505 55.548 9.95862V69.5726C55.548 75.1614 51.0459 79.5083 45.6124 79.5083H10.8375C5.24871 79.5083 0.901855 75.1614 0.901855 69.5726V9.95862C0.901855 4.52505 5.24871 0.0229492 10.8375 0.0229492H45.6124ZM48.0963 69.5726V9.95862C48.0963 8.71666 46.8543 7.4747 45.6124 7.4747H10.8375C9.44032 7.4747 8.35361 8.71666 8.35361 9.95862V69.5726C8.35361 70.9698 9.44032 72.0565 10.8375 72.0565H45.6124C46.8543 72.0565 48.0963 70.9698 48.0963 69.5726ZM33.1928 62.1209C34.4347 62.1209 35.6767 63.3628 35.6767 64.6048C35.6767 66.002 34.4347 67.0887 33.1928 67.0887H23.2571C21.8599 67.0887 20.7732 66.002 20.7732 64.6048C20.7732 63.3628 21.8599 62.1209 23.2571 62.1209H33.1928Z"
      className="navbar_icons_color navbar_icons_hover_color"
    />
  </svg>
);

export const Registrations = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g id="Layer_1" clipPath="url(#clip0_989_481)">
      <path
        id="Vector"
        d="M1.37073 1.28711H9.59913V3.85731H1.37073C0.891829 3.85731 0.5 3.46984 0.5 2.99627V2.14815C0.5 1.67458 0.891829 1.28711 1.37073 1.28711Z"
        className="navbar_icons_color navbar_icons_hover_color"
      />
      <path
        id="Vector_2"
        d="M1.37073 7.71484H3.09913V10.285H1.37073C0.891829 10.285 0.5 9.89757 0.5 9.424V8.57588C0.5 8.10231 0.891829 7.71484 1.37073 7.71484Z"
        className="navbar_icons_color navbar_icons_hover_color"
      />
      <path
        id="Vector_3"
        d="M7 7.71484H12.6293C13.1082 7.71484 13.5 8.10231 13.5 8.57588V9.424C13.5 9.89757 13.1082 10.285 12.6293 10.285H7V7.71484Z"
        className="navbar_icons_color navbar_icons_hover_color"
      />
      <path
        id="Vector_4"
        d="M1.37073 14.1426H7.64869V16.7128H1.37073C0.891829 16.7128 0.5 16.3253 0.5 15.8517V15.0036C0.5 14.53 0.891829 14.1426 1.37073 14.1426Z"
        className="navbar_icons_color navbar_icons_hover_color"
      />
      <path
        id="Vector_5"
        d="M11.5508 14.1426H12.6305C13.1094 14.1426 13.5012 14.53 13.5012 15.0036V15.8517C13.5012 16.3253 13.1094 16.7128 12.6305 16.7128H11.5508V14.1426Z"
        className="navbar_icons_color navbar_icons_hover_color"
      />
      <path
        id="Vector_6"
        d="M12.6307 0H11.7731C11.2922 0 10.9023 0.3855 10.9023 0.861038V4.27936C10.9023 4.7549 11.2922 5.1404 11.7731 5.1404H12.6307C13.1116 5.1404 13.5015 4.7549 13.5015 4.27936V0.861038C13.5015 0.3855 13.1116 0 12.6307 0Z"
        className="navbar_icons_color navbar_icons_hover_color"
      />
      <path
        id="Vector_7"
        d="M4.82606 6.42773H3.96839C3.4875 6.42773 3.09766 6.81323 3.09766 7.28877V10.7071C3.09766 11.1826 3.4875 11.5681 3.96839 11.5681H4.82606C5.30695 11.5681 5.69679 11.1826 5.69679 10.7071V7.28877C5.69679 6.81323 5.30695 6.42773 4.82606 6.42773Z"
        className="navbar_icons_color navbar_icons_hover_color"
      />
      <path
        id="Vector_8"
        d="M9.37684 12.8555H8.51917C8.03828 12.8555 7.64844 13.241 7.64844 13.7165V17.1348C7.64844 17.6104 8.03828 17.9959 8.51917 17.9959H9.37684C9.85773 17.9959 10.2476 17.6104 10.2476 17.1348V13.7165C10.2476 13.241 9.85773 12.8555 9.37684 12.8555Z"
        className="navbar_icons_color navbar_icons_hover_color"
      />
    </g>
  </svg>
);

export const Units = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g id="icon ">
      <g id="Union">
        <path
          d="M15.9888 6.18196C16.8903 2.70461 20.1101 0 23.9738 0H56.9443C60.6792 0 63.899 2.70461 64.8005 6.18196H15.9888Z"
          className="navbar_dropdown_icons_hover_color navbar_icons_color"
        />
        <path
          d="M59.0049 30.9098H65.1869V57.6983C65.1869 62.3348 61.452 65.9409 56.9443 65.9409H23.9738C19.3373 65.9409 15.7312 62.3348 15.7312 57.6983V30.9098H21.9132V57.6983C21.9132 58.8574 22.8147 59.759 23.9738 59.759H34.2771V51.5163C34.2771 48.1678 36.9817 45.3344 40.459 45.3344C43.8076 45.3344 46.641 48.1678 46.641 51.5163V59.759H56.9443C57.9746 59.759 59.0049 58.8574 59.0049 57.6983V30.9098Z"
          className="navbar_dropdown_icons_hover_color navbar_icons_color"
        />
        <path
          d="M27.0648 34.0008C27.0648 32.9705 27.9663 31.9401 29.1255 31.9401H35.3074C36.3377 31.9401 37.3681 32.9705 37.3681 34.0008V40.1828C37.3681 41.3419 36.3377 42.2434 35.3074 42.2434H29.1255C27.9663 42.2434 27.0648 41.3419 27.0648 40.1828V34.0008Z"
          className="navbar_dropdown_icons_hover_color navbar_icons_color"
        />
        <path
          d="M51.7926 31.9401C52.823 31.9401 53.8533 32.9705 53.8533 34.0008V40.1828C53.8533 41.3419 52.823 42.2434 51.7926 42.2434H45.6107C44.4516 42.2434 43.55 41.3419 43.55 40.1828V34.0008C43.55 32.9705 44.4516 31.9401 45.6107 31.9401H51.7926Z"
          className="navbar_dropdown_icons_hover_color navbar_icons_color"
        />
        <path
          d="M64.5115 12.3639C64.5115 11.3336 63.4812 10.3033 62.4509 10.3033H56.2689C55.1098 10.3033 54.2083 11.3336 54.2083 12.3639V23.6975C54.2083 25.5006 55.4962 26.7885 57.2992 26.7885H61.4205C63.0948 26.7885 64.5115 26.5309 64.5115 24.7278C64.5115 24.7278 64.5138 22.6672 62.4509 22.6672H58.3296V14.4246H62.4509C63.4812 14.4246 64.5115 13.523 64.5115 12.3639Z"
          className="navbar_dropdown_icons_hover_color navbar_icons_color"
        />
        <path
          d="M39.3567 12.3587C39.3567 11.3284 38.3264 10.2981 37.2961 10.2981H31.1141C29.955 10.2981 29.0535 11.3284 29.0535 12.3587V23.6923C29.0535 25.4954 30.3414 26.7833 32.1444 26.7833H36.2658C37.94 26.7833 39.3567 26.5257 39.3567 24.7227C39.3567 24.7227 39.359 22.662 37.2961 22.662H33.1748V20.3441H37.2961C38.3264 20.3441 39.3567 19.4426 39.3567 18.2835C39.3567 17.2531 38.3264 16.2228 37.2961 16.2228H33.1748V14.4194H37.2961C38.3264 14.4194 39.3567 13.5179 39.3567 12.3587Z"
          className="navbar_dropdown_icons_hover_color navbar_icons_color"
        />
        <path
          d="M26.71 12.3587C26.71 11.3284 25.6797 10.2981 24.6494 10.2981H18.4674C18.0113 10.2981 17.596 10.4576 17.2597 10.7139C17.0153 10.8815 16.8412 11.0953 16.717 11.3148C16.5215 11.6328 16.4089 11.9957 16.4067 12.3587C16.4067 12.3617 16.4083 12.3672 16.4114 12.3751C16.409 12.4167 16.409 12.44 16.409 12.44L16.409 15.5754C16.409 15.728 16.4287 15.8806 16.4662 16.0299C16.4613 16.9992 17.2923 17.6597 17.2923 17.6597L22.7273 21.9295V22.662H18.6061C17.4469 22.662 16.5454 23.6923 16.5454 24.7227C16.5454 26.7833 18.6061 26.7833 18.6061 26.7833H24.788C25.8184 26.7833 26.8487 25.8818 26.8487 24.7227C26.8487 24.6403 26.8421 24.5579 26.8294 24.476C26.8421 24.3943 26.8486 24.312 26.8486 24.2297V21.0943C26.8486 20.8947 26.8181 20.7027 26.7622 20.5216C26.6704 20.0485 26.4392 19.6079 26.0829 19.3248L20.5303 14.9626V14.4194H24.6494C25.6797 14.4194 26.71 13.5179 26.71 12.3587Z"
          className="navbar_dropdown_icons_hover_color navbar_icons_color"
        />
        <path
          d="M49.8041 10.2981C50.8345 10.2981 51.8648 11.3284 51.8648 12.3587C51.8648 13.5179 50.8345 14.4194 49.8041 14.4194H45.6851V14.9626L51.2377 19.3248C51.594 19.6079 51.8251 20.0485 51.917 20.5216C51.9729 20.7027 52.0034 20.8947 52.0034 21.0943V24.2297C52.0034 24.312 51.9968 24.3943 51.9842 24.476C51.9969 24.5579 52.0035 24.6403 52.0035 24.7227C52.0035 25.8818 50.9731 26.7833 49.9428 26.7833H43.7608C43.7608 26.7833 41.7002 26.7833 41.7002 24.7227C41.7002 23.6923 42.6017 22.662 43.7608 22.662H47.8821V21.9295L42.4471 17.6597C42.4471 17.6597 41.6161 16.9992 41.621 16.0299C41.5835 15.8806 41.5638 15.728 41.5638 15.5754V12.44C41.5638 12.44 41.5638 12.4167 41.5662 12.3751C41.5631 12.3672 41.5615 12.3617 41.5615 12.3587C41.5637 11.9957 41.6762 11.6328 41.8718 11.3148C41.9959 11.0953 42.1701 10.8815 42.4145 10.7139C42.7508 10.4576 43.1661 10.2981 43.6222 10.2981H49.8041Z"
          className="navbar_dropdown_icons_hover_color navbar_icons_color"
        />
      </g>
    </g>
  </svg>
);

export const Channels = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 67 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      id="Vector"
      d="M59.5165 45.9179C57.6328 45.9179 55.9061 46.7028 54.5718 47.8801L45.1534 42.4645C45.6243 41.1302 45.9383 39.639 45.9383 38.1477C45.9383 36.6565 45.6243 35.1652 45.1534 33.8309L54.5718 28.4154C55.8276 29.5927 57.5543 30.3775 59.438 30.3775C63.4409 30.3775 66.6588 27.1596 66.6588 23.1567C66.6588 19.1539 63.4409 15.9359 59.438 15.9359C55.4352 15.9359 52.2172 19.1539 52.2172 23.1567C52.2172 23.7061 52.2957 24.2555 52.4527 24.805L43.0343 30.2206C41.1506 27.9444 38.5605 26.3747 35.578 25.9038V14.9941C38.5605 14.0523 40.6797 11.3837 40.6797 8.08725C40.6797 4.08442 37.4617 0.866455 33.4589 0.866455C29.456 0.866455 26.2381 4.08442 26.2381 8.08725C26.2381 11.3052 28.4357 14.0523 31.3397 14.9941V25.8253C28.3572 26.3747 25.7671 27.9444 23.8835 30.1421L14.465 24.7265C14.622 24.1771 14.622 23.7061 14.622 23.0782C14.622 19.0754 11.404 15.8575 7.40121 15.8575C3.39838 15.8575 0.18042 19.0754 0.18042 23.0782C0.18042 27.0811 3.39838 30.299 7.40121 30.299C9.2849 30.299 11.0116 29.5142 12.3459 28.3369L21.7643 33.7525C21.2934 35.0867 20.9794 36.578 20.9794 38.0692C20.9794 39.5605 21.2934 41.0517 21.7643 42.386L12.3459 47.8016C11.0901 46.6243 9.36339 45.8394 7.40121 45.8394C3.39838 45.8394 0.18042 49.0574 0.18042 53.0602C0.18042 57.0631 3.39838 60.281 7.40121 60.281C11.404 60.281 14.622 57.0631 14.622 53.0602C14.622 52.5108 14.5435 51.9614 14.465 51.4905L23.8835 46.0749C25.7671 48.351 28.3572 49.9208 31.3397 50.3917V61.2229C28.3572 62.1647 26.2381 64.8333 26.2381 68.1297C26.2381 72.1325 29.456 75.3505 33.4589 75.3505C37.4617 75.3505 40.6797 72.1325 40.6797 68.1297C40.6797 64.9118 38.482 62.1647 35.578 61.2229V50.4702C38.5605 49.9208 41.1506 48.351 43.0343 46.1534L52.4527 51.569C52.2957 52.1184 52.2957 52.5893 52.2957 53.1387C52.2957 57.1416 55.5137 60.3595 59.5165 60.3595C63.5193 60.3595 66.7373 57.1416 66.7373 53.1387C66.7373 49.2144 63.4409 45.9179 59.5165 45.9179ZM33.4589 46.4673C28.9066 46.4673 25.1393 42.7785 25.1393 38.1477C25.1393 33.517 28.9066 29.8281 33.4589 29.8281C38.0111 29.8281 41.7785 33.5955 41.7785 38.1477C41.7785 42.7 38.0111 46.4673 33.4589 46.4673Z"
      className="navbar_icons_color navbar_dropdown_icons_hover_color"
    />
  </svg>
);

export const Personalities = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 66 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      id="&#239;&#154;&#164;"
      d="M33.2065 39.742C22.9852 39.742 14.7794 31.5361 14.7794 21.3148V0.584229L23.993 5.19102L33.2065 0.584229L42.4201 5.19102L51.6337 0.584229V21.3148C51.6337 31.5361 43.2839 39.742 33.2065 39.742ZM21.6896 19.0114V21.3148C21.6896 27.7931 26.7282 32.8318 33.2065 32.8318C39.5409 32.8318 44.7235 27.7931 44.7235 21.3148V19.0114H21.6896ZM40.1167 44.3488C54.0811 44.3488 65.4541 55.7218 65.4541 69.6861C65.4541 72.2775 63.2947 74.2929 60.8473 74.2929H5.56578C2.97446 74.2929 0.958984 72.2775 0.958984 69.6861C0.958984 55.7218 12.188 44.3488 26.2964 44.3488H40.1167ZM7.86918 67.3827H58.4C57.2483 58.3131 49.4743 51.259 40.1167 51.259H26.2964C16.7948 51.259 9.02087 58.3131 7.86918 67.3827Z"
      className="navbar_icons_color navbar_dropdown_icons_hover_color"
    />
  </svg>
);

export const KeyWords = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 70 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g id="Vector">
      <path
        d="M30.9829 58.405H64.3373C65.7271 58.405 67.1168 57.1889 67.1168 55.6255C67.1168 54.2357 65.7271 52.8459 64.3373 52.8459H30.9829C29.4194 52.8459 28.2034 54.2357 28.2034 55.6255C28.2034 57.1889 29.4194 58.405 30.9829 58.405Z"
        className="navbar_icons_color navbar_dropdown_icons_hover_color"
      />
      <path
        d="M22.6443 55.6255C22.6443 54.2357 21.2545 52.8459 19.8648 52.8459H3.18755C1.62407 52.8459 0.40802 54.2357 0.40802 55.6255C0.40802 57.1889 1.62407 58.405 3.18755 58.405H19.8648C21.2545 58.405 22.6443 57.1889 22.6443 55.6255Z"
        className="navbar_icons_color navbar_dropdown_icons_hover_color"
      />
      <path
        d="M3.18755 41.7278C1.62407 41.7278 0.40802 43.1175 0.40802 44.5073C0.40802 46.0708 1.62407 47.2869 3.18755 47.2869H36.542C37.9317 47.2869 39.3215 46.0708 39.3215 44.5073C39.3215 43.1175 37.9317 41.7278 36.542 41.7278H3.18755Z"
        className="navbar_icons_color navbar_dropdown_icons_hover_color"
      />
      <path
        d="M67.1168 44.5073C67.1168 43.1175 65.7271 41.7278 64.3373 41.7278H47.6601C46.0966 41.7278 44.8806 43.1175 44.8806 44.5073C44.8806 46.0708 46.0966 47.2869 47.6601 47.2869H64.3373C65.7271 47.2869 67.1168 46.0708 67.1168 44.5073Z"
        className="navbar_icons_color navbar_dropdown_icons_hover_color"
      />
      <path
        d="M69.5099 18.6938C69.5099 28.9151 61.3041 37.121 51.0828 37.121C42.1571 37.121 34.6711 30.7866 33.0875 22.1489H21.1386V29.0591C21.1386 31.0745 19.699 32.5142 17.6835 32.5142C15.812 32.5142 14.2284 31.0745 14.2284 29.0591V22.1489H7.31821V29.0591C7.31821 31.0745 5.87859 32.5142 3.86312 32.5142C1.99161 32.5142 0.40802 31.0745 0.40802 29.0591V18.6938C0.40802 16.8223 1.99161 15.2387 3.86312 15.2387H33.0875C34.6711 6.74491 42.1571 0.266602 51.0828 0.266602C61.3041 0.266602 69.5099 8.61642 69.5099 18.6938ZM51.0828 7.17679C44.7484 7.17679 39.5658 12.3594 39.5658 18.6938C39.5658 25.1721 44.7484 30.2108 51.0828 30.2108C57.5611 30.2108 62.5997 25.1721 62.5997 18.6938C62.5997 12.3594 57.5611 7.17679 51.0828 7.17679Z"
        className="navbar_icons_color navbar_dropdown_icons_hover_color"
      />
    </g>
  </svg>
);

export const Profile = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g id="perfil">
      <path
        id=".text"
        d="M12.5 12.5C15.5312 12.5 18 14.9688 18 18C18 18.5625 17.5312 19 17 19H5C4.4375 19 4 18.5625 4 18C4 14.9688 6.4375 12.5 9.5 12.5H12.5ZM5.5 17.5H16.4688C16.2188 15.5312 14.5312 14 12.5 14H9.5C7.4375 14 5.75 15.5312 5.5 17.5ZM11 11C8.78125 11 7 9.21875 7 7C7 4.8125 8.78125 3 11 3C13.1875 3 15 4.8125 15 7C15 9.21875 13.1875 11 11 11ZM11 4.5C9.59375 4.5 8.5 5.625 8.5 7C8.5 8.40625 9.59375 9.5 11 9.5C12.375 9.5 13.5 8.40625 13.5 7C13.5 5.625 12.375 4.5 11 4.5Z"
        className="navbar_dropdown_icons_hover_color navbar_icons_color"
      />
    </g>
  </svg>
);

export const Exit = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g id="logoff">
      <path
        id=".text"
        d="M8.25 16.5C8.65625 16.5 9 16.8438 9 17.25C9 17.6875 8.65625 18 8.25 18H6C4.3125 18 3 16.6875 3 15V7C3 5.34375 4.3125 4 6 4H8.25C8.65625 4 9 4.34375 9 4.75C9 5.1875 8.65625 5.5 8.25 5.5H6C5.15625 5.5 4.5 6.1875 4.5 7V15C4.5 15.8438 5.15625 16.5 6 16.5H8.25ZM18.7188 10.4688C18.9062 10.625 19 10.8125 19 11.0312C19 11.25 18.9062 11.4375 18.7188 11.5938L13.9688 15.75C13.7812 15.9375 13.5312 16.0312 13.2812 16.0312C13.125 16.0312 12.9688 16 12.8438 15.9375C12.4688 15.75 12.25 15.4062 12.25 15V13.2812H8.5C7.78125 13.2812 7.25 12.7188 7.25 12.0312V10.0312C7.25 9.3125 7.78125 8.78125 8.5 8.78125H12.25V7.03125C12.25 6.625 12.4688 6.28125 12.8438 6.09375C13.2188 5.9375 13.6562 6 13.9688 6.28125L18.7188 10.4688ZM13.75 13.9375L17.0938 11L13.75 8.0625V10.25H8.75V11.75H13.75V13.9375Z"
        className="navbar_dropdown_icons_hover_color navbar_icons_color"
      />
    </g>
  </svg>
);
